const CampaignChannelTypeConstants = Object.freeze({
  WHATSAPP: 1,
})
